import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { ApplicationErrorOptions } from '../../../types';
import type { PartnerTenant } from '@shipium-corp/shipium-ts-types';

export interface TenantsModel {
  tenantsMap: Record<string, PartnerTenant>;
  setTenants: Action<TenantsModel, PartnerTenant[]>;
  setTenant: Action<TenantsModel, PartnerTenant>;
  fetchTenantsLoading: boolean;
  setFetchTenantsLoading: Action<TenantsModel, boolean>;
  fetchTenants: Thunk<TenantsModel, void, Injections, StoreModel, Promise<void>>;
  fetchTenantsFailure: Action<TenantsModel, ApplicationErrorOptions>;
}

export const tenantsModel: TenantsModel = {
  tenantsMap: {},
  setTenants: action((state, tenants) => {
    const tenantsMap = tenants.reduce<Record<string, PartnerTenant>>((acc, curr) => {
      acc[curr.tenantId!] = curr;
      return acc;
    }, {});
    state.tenantsMap = tenantsMap;
  }),
  setTenant: action((state, tenant) => {
    state.tenantsMap[tenant.tenantId!] = tenant;
  }),
  fetchTenantsLoading: false,
  setFetchTenantsLoading: action((state, isLoading) => {
    state.fetchTenantsLoading = isLoading;
  }),
  fetchTenants: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchTenantsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchTenants();
      actions.setTenants(response);
      actions.setFetchTenantsLoading(false);
      return response;
    } catch (error) {
      actions.fetchTenantsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchTenantsLoading(false);
      return error;
    }
  }),
  fetchTenantsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default tenantsModel;
